<template>
  <div>
    <button class="btn btn-primary btn-sm"
        data-toggle="tooltip" 
        data-placement="top" 
        title="New"
        @click="fnShowModal()">New
    </button>

    <b-modal ref="modal" hide-footer title="Transmission - new">
        <div class="d-block">
        <form v-on:submit.prevent="createNew">

            <div class="form-group">
                <label for="transmission">Code</label>
                <input type="text" 
                class="form-control" 
                id="transmission" 
                placeholder="Transmission"
                v-model="transmission">
                <div class="invalid-feedback" v-if="errors.transmission">{{ errors.transmission[0] }}</div>
            </div>
        <hr>
        <div class="text-right">
            <button type="button" class="btn btn-secondary btn-sm mr-2" @click="hideModal">Cancel</button>
            <button type="submit" class="btn btn-primary btn-sm">Save</button>
        </div>
        </form>
        </div>
    </b-modal>
  </div>
</template>
<script>
    import { mapActions } from 'vuex';
    import * as messageService from '../../services/message.service';
    import * as transmissionService from '../../services/transmission.service';
    export default {
        name:"ModalTransmissionNew",
        components: {
            
        },
        data(){
            return{
                errors:{},
                transmission:'',
            }
        },
        methods:{
            ...mapActions(['fetchTransmissionAll']),
            fnShowModal(){
                this.showModal();
            },
            hideModal(){
                this.$refs.modal.hide();
            },
            showModal(){
                this.$refs.modal.show();
            },

            createNew:async function(){
                const formData = new FormData();
                formData.append('transmission',this.transmission);
            try{
                await transmissionService.add(formData);
                this.hideModal();
                this.fetchTransmissionAll();

                messageService.fnSweetAlertSuccessToast('Transmission - new', 'added successfully');

                this.transmission = '';

                }catch(error){
                    switch (error.response.status){
                    case 422:
                        this.errors = error.response.data.errors;
                        break;

                    case 500:
                        messageService.fnSweetAlertErrorToast('Transmission - new', error.response.data.message);
                        break;

                    default:
                            messageService.fnSweetAlertErrorToast('Transmission - new', 'Something wrong');
                        break;
                    }
                }
            },
        }
    }
</script>